<template>

  <section class="white mb-5 relative nooverflow">

			<div id="mainSectionBottomBgr" style="height: 100px;width: 100%;background: linear-gradient(9deg, rgb(31, 189, 113), rgba(191, 255, 234, 0.95));position: absolute;top: -54px;transform: rotate(181deg);"></div>

			<v-layout column wrap class="mt-5" align-center>
				<v-flex xs12 sm4>
					<br/>
					<br/>
					<br/>
					<br/>
					<div class="text-xs-center mt-5">
						<h2 class="display-2 mb-3 font-weight-light">
							What's In It
						</h2>
					</div>
				</v-flex>
				<v-flex xs12>
					<v-container grid-list-xl class="pl-5 pr-5 mt-2">
						<v-layout row wrap align-center>
							<v-flex sm12 lg4 class="feature-container" align-center>
								<v-layout column align-center>
								<v-card class="elevation-0 transparent ml-2 mr-2 feature-block">
									<v-card-text class="text-xs-center relative feature-icon-holder">
										<v-icon class="feature-icon-bgr" style="bottom: -35px;left: 33%;transform: rotate(201deg);">bubble_chart</v-icon>
										<img class="feature-icon" src="../../../assets/feat1Icon.png"/>
									</v-card-text>
									<v-card-title primary-title class="layout justify-center primary--text">
										<div class="feature-headline headline text-xs-center">Instant</div>
									</v-card-title>
									<v-card-text class="text-xs-center feature-text">
										Get instant high quality pronunciation of your text content
										in more than thirty languages and dialects. No need to wait
										days and weeks to get your audio content
									</v-card-text>
								</v-card>
								</v-layout>
							</v-flex>
							<v-flex sm12 lg4 class="feature-container" align-center>
								<v-layout column align-center>
								<v-card class="elevation-0 transparent ml-2 mr-2 feature-block">
									<v-card-text class="text-xs-center relative feature-icon-holder">
										<v-icon class="feature-icon-bgr" style="bottom: -21px;left:45%;transform: rotate(45deg);">bubble_chart</v-icon>
										<img class="feature-icon" src="../../../assets/feat2Icon.png"/>
									</v-card-text>
									<v-card-title primary-title class="layout justify-center primary--text">
										<div class="feature-headline headline text-xs-center">Easy</div>
									</v-card-title>
									<v-card-text class="text-xs-center feature-text">
										Choose between different female and male characters to better
										engage with your target audience. Choose the needed audio encoding
										and have the content downloaded in a few seconds
									</v-card-text>
								</v-card>
								</v-layout>
							</v-flex>
							<v-flex sm12 lg4 class="feature-container" align-center>
								<v-layout column align-center>
								<v-card class="elevation-0 transparent ml-2 mr-2 feature-block">
									<v-card-text class="text-xs-center relative feature-icon-holder">
										<img class="feature-icon" src="../../../assets/feat3Icon.png"/>
										<v-icon class="feature-icon-bgr" style="bottom: -16px;left:38%;">bubble_chart</v-icon>
									</v-card-text>
									<v-card-title primary-title class="layout justify-center primary--text">
										<div class="feature-headline headline text-xs-center">Cheap</div>
									</v-card-title>
									<v-card-text class="text-xs-center feature-text">
										Get our word count based packages and pay via your PayPal account.
										We charge only for the number of text words converted to audio as
										this is what is valuable for our customers
									</v-card-text>
								</v-card>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
			</v-layout>
		</section>


</template>

<style scoped>

@media (max-width: 1380px) {
	#mainSectionBottomBgr {
		display:none !important;
	}
}

.feature-block {
	width:360px;
}

.feature-text {
	font-size: 1.15rem;
    font-weight: 300;
}

.feature-container {
	min-height:435px;
}

.feature-container:hover .feature-icon{
 transform: scale(1.05);
}

.feature-container:hover .feature-icon-bgr{
	bottom:-10px !important;
}

.feat-container:hover .feat-headline{
 color:#0fbcda;
}

.feature-icon {
 transition: transform 0.6s;
 position:relative;
 z-index:2;
	--border: 1px solid #0fbe84;
	--padding: 22px 63px;
	--border-radius: 93px;
	--background:#f9f8f4;
	--background:#f3f7f9;
}

.feature-icon-bgr {
	transition: all 0.8s;
	position: absolute;
	font-size: 115px;
	z-index: 1;
	color: #e2dfd775 !important;
}


</style>

<script>

export default {
  name: "features_section",
  data() {
    return {
    };
  }
};
</script>
